import type { ReactNode } from 'react';
import { Svg } from '../primitives/Svg.js';
import type { IconProps } from '../primitives/types.js';

export function IcnFolder(props: IconProps): ReactNode {
  return (
    <Svg {...props} iconName="folder">
      <path d="M2 5V4a1 1 0 0 1 1-1h3l1.5 1.5H13a1 1 0 0 1 1 1V12a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V5z" />
    </Svg>
  );
}
